<template>
  <div class="welcome">
    <div class="welcome-wrapper">
      <p style="text-align: center;font-size: 20px;position: relative;top:30px;z-index: 1">区域学校分布</p>
      <div id="mapChart" :style="{ height: '100%'}" v-show="show">
      </div>
    </div>
  </div>
</template>

<script>
  import 'echarts/map/js/china.js';
  import china from './china'
  import {baseUrl} from 'common/api/api'
  export default {
    data(){
      return{
        baseUrl:baseUrl,
        det:[],
        show:true,
        chart:[
          {name: '北京',value: 0},
          {name: '天津',value: 0},
          {name: '上海',value: 0 },
          {name: '重庆',value: 0},
          {name: '河北',value: 0},
          {name: '河南',value: 0},
          {name: '云南',value: 0},
          {name: '辽宁',value: 0},
          {name: '黑龙江',value:0},
          {name: '湖南',value: 0},
          {name: '安徽',value: 0},
          {name: '山东',value: 0},
          {name: '新疆',value: 0 },
          {name: '江苏',value: 0 },
          {name: '浙江',value: 0},
          {name: '江西',value: 0},
          {name: '湖北',value: 0 },
          {name: '广西',value:0},
          {name: '甘肃',value: 0 },
          {name: '山西',value: 0 },
          {name: '内蒙古',value: 0},
          {name: '陕西',value: 0 },
          {name: '吉林',value: 0 },
          {name: '福建',value: 0 },
          {name: '贵州',value: 0 },
          {name: '广东',value: 0 },
          {name: '青海',value: 0 },
          {name: '西藏',value: 0 },
          {name: '四川',value: 0 },
          {name: '宁夏',value: 0 },
          {name: '海南',value: 0 },
          {name: '台湾',value: 0 },
          {name: '香港',value: 0 },
          {name: '澳门',value: 0 },
          {name:'南海诸岛',value:0}
        ]
      }
    },
    methods:{
      //绘制地图
      mapChart () {
        // console.log(this.chart)
        let myChart = this.$echarts.init(document.getElementById('mapChart'));
        let option = {
          backgroundColor: '#ffffff',
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              let htmlStr='<div>';
              htmlStr+='<p>'+params.name+'</p>'+'<span style="margin-right: 5px">'+params.seriesName+':'+'</span>'+'<span>'+params.value+'</span>'+'<div>';
              return htmlStr;
            }
          },
          visualMap: {//颜色的设置  dataRange
            show:true,
            orient:"vertical",
            x: '8%',
            y: '68%',
            splitList: [    // 数据层级，每层用一个颜色标识，可以自定每级的数值范围
              {end: 1, color: '#E2EBF3'},
              {start: 1, end:60, color: '#90BCF0'},
              {start:60, end: 100, color: '#5B9CE9'},
              {start: 100, color: '#3385E3'},
            ],
            //text:['高','低'],// 文本，默认为数值文本
          },
          series: [
            {
              width:780,
              name: '学校数量',
              type: 'map',
              mapType: 'china',
              roam: false,

              itemStyle:{
                normal:{
                  label:{
                    show:true,
                  },
                  borderWidth:1,
                  //borderColor:'#BFC9DA',
                  borderColor:'#B5BED4',
                  areaColor: '#E2EBF3' // 地图颜色
                },
                emphasis:{
                  areaColor: "#78CFA2",
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  shadowBlur: 10,
                  borderWidth: 0,
                  shadowColor: 'rgba(120, 207, 162, 0.5)'
                },

              },
              // data:getMapData,   如果是异步的动态数据 在这里赋值
              data:this.chart
            }
          ]
        };
        myChart.setOption(option);
      },
      //获取全国身份学校数量
      getData(){
        this.chart.map(item=>{
          this.$http({
            method: 'POST',
            url: baseUrl + '/proxy/queryinproxyschoolcount',
            params:{
              'proName': item.name
            },
          }).then((res) => {
            if(res.body.code==0){
              item.value = res.body.data.schoolCount
            }
          })
        })
      },
      //先获取数量，再绘制地图
      getChartData(){
        setTimeout(() => {
          this.getData()
          setTimeout(() => {
            this.mapChart()
          }, 500);
        }, 500);

      }

    },
    mounted() {
      this.getChartData();

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "~common/scss/variable.scss";
  .welcome{
    // padding:20px 15px;
    height: -webkit-calc(100% - (0px));
    height: -moz-calc(100% - (0px));
    height: calc(100% - (0px));
    background-color:$color-background-white;
    border:1px solid $color-border;
    .welcome-wrapper{
      position:relative;
      height:100%;
      h1{
        padding-bottom:15px;
        border-bottom:2px solid $color-border;
      }
      .welcome-content{
        position:absolute;
        width:100%;
        text-align: center;
        /*top:50%;*/
        margin-top:20px;
        p{
          height:52px;
          line-height: 52px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/welcome/welcome.vue